import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentos'
})
export class DocumentosPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
